import flatTemplate from "./FlatPage.ejs"
import sectionsMapMenu from "../../components/SectionsMapMenu/SectionsMapMenu";
import sectionsMapView from "../../components/SectionsMapView/SectionsMapView";
import makeTemplateFunc from "lodash/template"
import {Preloader, housingNav} from "../../components"
import {
  getFlat,
  registerPreloader,
  addFlatToFavorites,
  removeFlatFromFavorites
} from "../../api"
import $ from "jquery";
import "../../components/SendToEmailPopup/SendToEmailPopup";
import "../../components/CallbackPopup/CallbackPopup";

const flatTemplateFunc = makeTemplateFunc(flatTemplate);

class FlatSimilar {
  constructor(flatId, similarApartments, app) {
    this.index = 1;
    this.flats = [flatId].concat(similarApartments);
  }

  getCount() {
    return this.flats.length;
  }

  getNextSimilar() {
    if (this.getCount() > this.index) {
      this.index += 1;
    } else {
      this.index = 1;
    }
    return this.flats[this.index - 1]
  }

  getIndex() {
    return this.index;
  }

  getPrevSimilar() {
    if (this.index > 1) {
      this.index -= 1;
    } else {
      this.index = this.getCount();
    }
    return this.flats[this.index - 1]
  }
}

export class FlatPage {

  constructor($container, params, app) {
    this.$container = $container;
    this.params = params;
    this.app = app;
    registerPreloader(new Preloader(this.$container));
  }

  handleClickBanner(ev) {
    ev.preventDefault();
    $(ev.currentTarget).addClass('hidden');
    window.flatBannerHidden = true;
  }

  handlePrevFlat(ev) {
    ev.preventDefault();

    this.params.id = this.similar.getPrevSimilar();

    const $link = this.$container.find('.js-prev-flat');
    const housingCode = $link.data('housing-code'),
      section = $link.data('section'),
      floor = $link.data('floor'),
      floorNumber = $link.data('floorNumber');

    this.app.pushState('FLAT_PAGE', {
      HOUSING_CODE: housingCode,
      SECTION_ID: section,
      FLOOR_ID: floor,
      FLOOR_NUM: floorNumber,
      APARTMENT_ID: this.params.id,
    }, {
      id: this.params.id
    }, true);

    this.render()
  }

  handleNextFlat(ev) {
    ev.preventDefault();

    this.params.id = this.similar.getNextSimilar();

    const $link = this.$container.find('.js-next-flat');
    const housingCode = $link.data('housing-code'),
      section = $link.data('section'),
      floor = $link.data('floor'),
      floorNumber = $link.data('floorNumber');;

    this.app.pushState('FLAT_PAGE', {
      HOUSING_CODE: housingCode,
      SECTION_ID: section,
      FLOOR_ID: floor,
      FLOOR_NUM: floorNumber,
      APARTMENT_ID: this.params.id,
    }, {
      id: this.params.id
    }, true);

    this.render()
  }

  updateFavorite(fResponse) {
      $('.sidebar-favorites__count').text(fResponse.count);
  }

  handleFavorite(ev) {
    ev.preventDefault();
    let $currentEl = $(ev.currentTarget);

    if($currentEl.hasClass('in-favorites')) {
      removeFlatFromFavorites(this.app.apiPaths.REMOVE_FAVORITE, {'apartmentId': this.params.id}).then((fResponse) => this.updateFavorite(fResponse));
      $currentEl.removeClass('in-favorites');
    } else {
      addFlatToFavorites(this.app.apiPaths.ADD_FAVORITE, {'apartmentId': this.params.id}).then((fResponse) => this.updateFavorite(fResponse));
      $currentEl.addClass('in-favorites');
    }

  }

  render() {
    getFlat(this.app.apiPaths.FLAT, this.params).then(this.renderPage.bind(this));
  }

  renderPage(response) {
    if (!this.similar) {
      this.similar = new FlatSimilar(
        response.responseJSON['id'],
        response.responseJSON['similarApartments'],
          this.app
      );
    }

    this.$container.addClass('h100');
    this.$container.html(flatTemplateFunc({
      response,
      similar: this.similar
    }));
    sectionsMapMenu.render(this.$container.find('.js-sections-map-menu'), response);
    sectionsMapView.render(this.$container.find('.js-sections-map-view'), response);

    this.$container.find('.js-hide-banner').on('click', this.handleClickBanner.bind(this));
    this.$container.find('.js-next-flat').on('click', this.handleNextFlat.bind(this));
    this.$container.find('.js-prev-flat').on('click', this.handlePrevFlat.bind(this));
    this.$container.find('.js-favorite').on('click', this.handleFavorite.bind(this));
    this.$container.find('.js-get-section').on('click', this.app.handleSectionClick.bind(this));
    this.$container.find('.js-get-floor').on('click', this.app.handleFloorClick.bind(this));

    housingNav.actualize(response.responseJSON.prevHousing, response.responseJSON.nextHousing);

    $('.js-expand-right-col').click((e) => this.app.handleRightColExpand(e));

    this.app.initScroll();
  }

}



// WEBPACK FOOTER //
// ./js/pages/FlatPage/FlatPage.js